import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import GradingTypeForm from '../../../components/forms/GradingTypeForm';
import { useGradingTypeApi } from '../../../hooks/useGradingTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { GradingTypeDTO } from '../../../services/apiClient';

const GradingTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useGradingTypeApi();
  const [entityData, setEntityData] = useState<GradingTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Grading Types', href: '/admin/gradingtypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Grading Type data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/gradingtypes');
    } catch (error) {
      console.error('Error updating Grading Type:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/gradingtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.GradingType.Edit'
    >
        {entityData ? (
          <GradingTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/gradingtypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default GradingTypeEdit;